<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  name: "App",
  created() {
    window.addEventListener("beforeunload", () => {
      Cookies.set("SXR50storeCache", JSON.stringify(this.$store.state));
    });
    // 获取localStorage中的store数据
    const storeName = Cookies.get("SXR50storeCache");
    if (storeName) {
      // 将localStorage中的store数据替换到store中
      const oldStore = JSON.parse(storeName);
      if (oldStore.page) {
        delete oldStore.page;
      }
      if (oldStore.settings) {
        delete oldStore.settings;
      }
      const merge = Object.assign(this.$store.state, oldStore);
      this.$store.replaceState(merge);
      Cookies.remove("SXR50storeCache");
    }
  },
};
</script>
